// PhonicsLt02.js
// 包装组件：Letter Teams L02
// 路由：/phonics/lt02
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt02 } from './phonics/phonics_data_lt02';

function PhonicsLt02() {
  return <PhonicsLt letterData={letterDataLt02} />;
}

export default PhonicsLt02;
